module.exports = __webpack_public_path__ + "img/e3befa4.png";